import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DeletePopUp from '../Shared/DeletePopUp';
import { toast } from 'react-toastify';
import { closeBrPrivModal } from '../../Store/Slices/brPrivSlice';
import { useDeleteMappingMutation } from '../../Store/Services/BrPrivService';


const DeleteBrPriv = () => {

    const dispatch = useDispatch();
    const brPriv = useSelector((state) => state.brPriv);

    const [deleteBrPriv] = useDeleteMappingMutation();

    const onDeleteConfirm = async () => {
        const id = brPriv.selectedBrPriv;
        try {
            const deletedBrPriv = await deleteBrPriv(id).unwrap();
            // toast.success("BrPriv successfully deleted!");
        } catch (err) {
            console.error('Failed to delete the brPriv: ', err)
            toast.error("Erorr, something went wrong!");
        }
        dispatch(closeBrPrivModal());
    }

    return (
        <DeletePopUp
            data="Privilege mapping to the Role"
            close={() => dispatch(closeBrPrivModal())}
            onDeleteConfirm={onDeleteConfirm}
        />
    )
}

export default DeleteBrPriv